import React, { useEffect } from 'react';
import { CheckCircle, Info, XCircle, X } from 'lucide-react';
interface ToastProps {
  message: string;
  variant: 'success' | 'info' | 'error';
  onClose: () => void;
}
export function Toast({
  message,
  variant,
  onClose
}: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);
  const variantStyles = {
    success: {
      bg: 'bg-green-600',
      icon: <CheckCircle className="h-5 w-5 text-white" strokeWidth={2} data-id="element-91" />
    },
    info: {
      bg: 'bg-blue-600',
      icon: <Info className="h-5 w-5 text-white" strokeWidth={2} data-id="element-92" />
    },
    error: {
      bg: 'bg-red-600',
      icon: <XCircle className="h-5 w-5 text-white" strokeWidth={2} data-id="element-93" />
    }
  };
  const style = variantStyles[variant];
  return <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[100] animate-slide-in-top" data-id="element-94">
      <div className={`${style.bg} text-white rounded-xl shadow-xl px-4 py-3 flex items-center gap-3 min-w-[280px] max-w-md`} data-id="element-95">
        {style.icon}
        <p className="text-sm font-normal flex-1" data-id="element-96">{message}</p>
        <button onClick={onClose} className="text-white/80 hover:text-white transition-colors" data-id="element-97">
          <X className="h-4 w-4" strokeWidth={2} data-id="element-98" />
        </button>
      </div>
    </div>;
}